import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { CabecalhoModule } from '../../components/cabecalho/cabecalho.module';
import { DescricaoModule } from '../../components/descricao/descricao.module';

import { CaseGeneraliComponent } from './case-generali.component';
import { DetalhesModule } from '../../components/detalhes/detalhes.module';
import { ResultadosModule } from '../../components/resultados/resultados.module';
import { DepoimentoModule } from '../../components/depoimento/depoimento.module';

@NgModule({
  declarations: [
    CaseGeneraliComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoModule,
    DescricaoModule,
    DetalhesModule,
    ResultadosModule,
    DepoimentoModule
  ],
  exports: [
    CaseGeneraliComponent
  ]
})

export class CaseGeneraliModule { }
